<template>
  <custom-callout
    class-main="mt-3 rounded"
    :controlled="true"
    :opened="showHistory"
    @click:open="openHistory"
  >
    <div class="row py-2 mr-md-0 align-items-center">
      <div class="col col-sm col-12 mt-3 mt-md-0 border-right">
        <div class="color-gray-6 font-14">Periodo:</div>
        <div class="color-black font-16">
          <strong>{{ data.period }}</strong>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Presupuesto:</div>
        <div class="font-16">
          <span>{{ data.budget | price }}</span>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Pagado:</div>
        <div class="font-16">
          <span>{{ data.paid | price }}</span>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">En proceso de pago:</div>
        <div class="font-16">
          <span>{{ data.inPaymentProcess | price }}</span>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Pendiente:</div>
        <div class="font-16">
          <span>{{ data.pending | price }}</span>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <div class="color-gray-6 font-14">Disponible:</div>
        <div class="font-16" :class="getColor">
          <strong>{{ data.available | price }}</strong>
        </div>
      </div>
      <div class="col col-sm col-12 mt-3 mt-md-0">
        <action-button
          v-if="canAdjust"
          i="fas fa-solid fa-file-invoice-dollar pl-0"
          text="Ajustar Presupuesto"
          variant="outline-success px-4"
          @click="openChangeBudget"
        />
      </div>
    </div>
    <template #edition>
      <div v-if="showHistory && !changeBudget" class="p-2">
        <budget-history
          :available-budget="data.available"
          :fetch-more-budget-history="fetchMoreBudgetHistory"
          :show-fetch-more="showFetchMore"
          :value="historyResult"
        />
      </div>
      <div v-if="changeBudget" class="p-1">
        <adjust-budget
          :item="data"
          @on-cancel="onCancelHandler"
          @on-save="onAdjustBudget($event)"
        />
      </div>
    </template>
  </custom-callout>
</template>

<script>
import ActionButton from 'ActionButton';
import CustomCallout from 'custom-callout';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import BudgetHistory from './BudgetHistory.vue';
import { adjustBudget as _adjustBudget } from '@/views/support/modules/shared/budget.api.js';
import { getBudgetHistory as _getBudgetHistory } from '@/views/support/modules/shared/budget-history.api';
import AdjustBudget from './AdjustBudget.vue';
const DEFAULT_PAGE_SIZE = 3;
const INCREMENT_PAGE_SIZE = 3;
const initialFilterModel = () => ({
  annualBudgetId: null,
});

export default {
  name: 'ResultRow',
  mixins: [alertMixin],
  components: {
    CustomCallout,
    ActionButton,
    BudgetHistory,
    AdjustBudget,
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        id: null,
        academicYearId: null,
        period: null,
        budget: null,
        paid: null,
        inPaymentProcess: null,
        pending: null,
        available: null,
      }),
    },
  },
  data() {
    return {
      showHistory: false,
      changeBudget: false,
      showFetchMore: false,
      historyResult: [],
      filterModel: { ...initialFilterModel() },
      pageSize: DEFAULT_PAGE_SIZE,
    };
  },
  computed: {
    getColor() {
      return this.data.available >= 0 ? 'color-green' : 'color-red';
    },
    incrementSize() {
      return this.historyResult.length + INCREMENT_PAGE_SIZE;
    },
    canAdjust() {
      return this.userHasPermissions('rempro.budget.adjust');
    },
  },
  methods: {
    async openHistory() {
      this.showHistory = !this.showHistory;
      if (!this.showHistory) {
        this.pageSize = DEFAULT_PAGE_SIZE;
        return;
      }

      await this.onSearchHandler();
      this.$emit('on-open-close');
    },
    async openChangeBudget() {
      this.openHistory();
      this.changeBudget = true;
      if (!this.showHistory) return;
    },
    async fetchMoreBudgetHistory() {
      this.pageSize = this.incrementSize;
      await this.onSearchHandler();
    },
    onCancelHandler() {
      this.changeBudget = false;
      this.showHistory = false;
    },
    async onAdjustBudget(item) {
      const confirm = await this.ShowCancelModal(
        'Confirmación',
        `¿Está seguro(a) que desea ajustar el presupuesto del año académico ${item.period}`,
        'Sí',
        'No'
      );

      if (confirm) {
        await _adjustBudget(item)
          .then(({ data }) => {
            this.ShowToast(
              'Proceso exitoso.',
              'El presupuesto ha sido ajustado exitosamente.',
              'success'
            );
            this.onCancelHandler();
            this.$emit('on-budget-adjusted', data);
          })
          .catch((err) =>
            this.ShowToast(
              'Alerta',
              err?.response.data.message || 'error',
              'error'
            )
          );
      }
    },
    async onSearchHandler(pageIndex = 1) {
      const searchParams = {
        annualBudgetId: this.data.id,
        pageIndex,
        pageSize: this.pageSize,
      };

      const { data: res } = await _getBudgetHistory(searchParams);

      this.historyResult = [...res.data];
      this.showFetchMore = res.count < res.totalItemCount;
    },
  },
};
</script>

<style scoped lang="scss">
.btn-action-size {
  width: 35px;
  height: 35px;
}
.history-title {
  color: #3f5b60;
  font-size: 1rem;
  font-family: Lato;
  font-weight: bold;
}
</style>
